import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import Slider from "react-slick";
import { SportQ } from '../../graphqlDic'
import { graphql, compose } from 'react-apollo'
import {Link} from 'react-router-dom'
class SportItem extends Component {

    showMoreDetail = dataDetail => {
        let result = '';
        if (dataDetail.length) {
            dataDetail.map((detail, index) => {
                if (detail.name) result += detail.name + ', ';
                return null;
            });
        }
        return result.slice(0, -2);
    }

    showGenre = dataGenre => {
        let result = '';
        if (dataGenre.length) {
            dataGenre.map((genre, index) => {
                if (genre.name && genre.genre === 2) result += genre.name + ', ';
                return null;
            });
        }
        return result ? result.slice(0, -2) : 'Không có';
    }

    render() {

        if (this.props.getSportMediasByTypeCategories.loading) return "Loading...";
        if (this.props.getSportMediasByTypeCategories.error) return `Error! ${this.props.getSportMediasByTypeCategories.error.message}`;
        var sport_item = this.props.getSportMediasByTypeCategories.getSportMediasByTypeCategories;
        let settingsSlickSport = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToScroll: 8,
            slidesToShow: 8,
            responsive: [
                {
                    breakpoint: 1650,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6,
                        dots: true
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        dots: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        };
        const ItemSport = sport_item.length ? sport_item.map((item,i) =>
            <div key={i}>
                <div className="block-index-title text-blue">{item.name}</div>
                <div className="index-another-slick block-index-common block-sport">
                    <Slider {...settingsSlickSport}>
                    {
                        item.medias.map((media, k) =>
                            <Link key={k} to={"/the-thao/" + item.slug + "/watch/" + media.id}>
                                <div className="unit">
                                    <div className="img">
                                        <img src={media.img} alt={media.img} />
                                    </div>
                                    <div className="name">
                                        <span>{media.name}</span>
                                    </div>
                                    <div className="sub-name">
                                        <img src={'/images/icon-play.png'} alt="true" />
                                        <span>{media.name}</span>
                                        {media.scoreImdb &&
                                            <div>
                                                IMDb: <span className="point">{media.scoreImdb}</span>
                                            </div>
                                        }
                                        { /*item.categories && item.categories.length && <div>Thể loại: {this.showGenre(item.categories)}</div> */}
                                        { media.nations && media.nations.length ? <div>Quốc gia: {this.showMoreDetail(media.nations)}</div> : null }
                                        { media.languages && media.languages.length ? <div>Ngôn ngữ: {this.showMoreDetail(media.languages)}</div> : null }
                                    </div>

                                </div>
                            </Link>
                        )
                    }
                    </Slider>
                </div>
            </div>
        ) : "Không có dữ liệu";
        return (
            <Fragment>
                {ItemSport}
            </Fragment>
        );
    }
}
export default compose(
    graphql(SportQ,{
        name:'getSportMediasByTypeCategories',
        options: (ownProps) => ({
            variables: {
                type: ownProps.type
            }
        })
    })
)(withRouter(
    connect(
        null
    )(SportItem)
))




// WEBPACK FOOTER //
// ./src/components/Sports/SportItem.js